import { useDispatch, useSelector } from "react-redux";
import { BubbleBot } from "../BubbleBot/BubbleBot";
import { BubbleUser } from "../BubbleUser/BubbleUser";
import { useEffect } from "react";
import { BubbleUserActual } from "../BubbleUser/BubbleUserActual";
import { BubbleBotActual } from "../BubbleBot/BubbleBotActual";
import { updatePriceRedux } from "../../actions/price.actions";

export const ContainerBot = () => {
  const dispatch = useDispatch();
  const formDataDic = useSelector((state) => {
    return state.formDataDic;
  });

  useEffect(() => {
    const priceDic = formDataDic?.formData?.find((e) => {
      return e.id === 4;
    });
    if (priceDic) {
      dispatch(updatePriceRedux(priceDic?.answer));
    }
  }, [formDataDic, dispatch]);

  return (
    <div className="flex flex-col gap-2">
      <details className="collapse card bg-gradient-to-r from-green-400 to-blue-500 my-4 px-4 collapse-arrow">
  <summary className="collapse-title text-sm lg:text-md font-medium text-white">Voir ou modifier mes anciennes réponses</summary>
  <div className="collapse-content">      
      {formDataDic &&
        formDataDic?.formData?.map((e, index) => {
          return (
            <div key={index} className="flex flex-col">
              <BubbleBot id={e.id} content={e.question} />
              <BubbleUser id={e.id} content={e.answer} lastQuestion={false} />
            </div>
          );
        })}
          </div>
</details>
      <div className="flex flex-col gap-2">
        <BubbleBotActual />
        <BubbleUserActual />
      </div>
    </div>
  );
};
